import { Accordion, AccordionDetails, AccordionSummary, IconButton, Stack, Typography } from '@mui/material';
import React, { FC, ReactNode, useState } from 'react';
import MessageIcon from '@mui/icons-material/Message';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Delete } from '@mui/icons-material';
import MuiDialog from '../mui-dialog/MuiDialog';

interface AccordionComponentProps {
	summaryTitle: string;
	children: ReactNode;
	hasComment?: boolean;
	showDeleteButton?: boolean;
	onDelete?: () => void;
	dialogTitle?: string;
	dialodContent?: string;
}

const MUIAccordionComponent: FC<AccordionComponentProps> = ({
	summaryTitle,
	children,
	hasComment = false,
	showDeleteButton = true,
	onDelete,
	dialogTitle,
	dialodContent,
}) => {
	const [openDialog, setOpenDialog] = useState(false);

	const handleOpenDeletedialog = (e: any) => {
		e.stopPropagation();
		setOpenDialog(true);
	};

	const handleDelete = () => {
		setOpenDialog(false);
		if (onDelete) {
			onDelete();
		}
	};

	return (
		<>
			<MuiDialog
				open={openDialog}
				title={dialogTitle ? dialogTitle : 'Löschen'}
				content={dialodContent ? dialodContent : 'Sind Sie sicher, dass Sie diesen Eintrag löschen möchten?'}
				onClose={() => setOpenDialog(false)}
				onConfirm={() => handleDelete()}
			/>
			<Accordion defaultExpanded>
				<AccordionSummary expandIcon={<ExpandMoreIcon />}>
					<Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} sx={{ width: '100%' }}>
						<Typography>
							{summaryTitle} {hasComment && <MessageIcon fontSize="small" />}
						</Typography>
						{showDeleteButton && (
							<IconButton onClick={handleOpenDeletedialog} sx={{ padding: 0, paddingRight: '1rem', paddingLeft: '1rem' }}>
								{' '}
								<Delete />
							</IconButton>
						)}
					</Stack>
				</AccordionSummary>
				<AccordionDetails>{children}</AccordionDetails>
			</Accordion>
		</>
	);
};
export default MUIAccordionComponent;
